import { type InteractionType, type ProspectDto } from "@crowdcoursing/api/openapi";
import { useState } from "react";

import { useToast } from "~hooks/useToast";

import { useProspectDetails } from "./useProspectDetails";

export const useInteractionModal = (prospectId: string) => {
  const toast = useToast();
  const { addNewInteraction, updateExistingInteraction, deleteInteraction } = useProspectDetails(prospectId);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editInteraction, setEditInteraction] = useState<NonNullable<ProspectDto["interactions"]>[number] | null>(null);
  const [interactionType, setInteractionType] = useState<InteractionType>(1);

  const handleAddInteraction = async (values: {
    type: InteractionType;
    subject: string;
    notes: string;
    contactId: string | null;
    occurredAt: string;
  }) => {
    try {
      await addNewInteraction(values);
      setIsAddOpen(false);
      toast.success("Interaction logged successfully");
    } catch (error) {
      console.error("Error logging interaction:", error);
      toast.error("Failed to log interaction");
    }
  };

  const handleUpdateInteraction = async (values: {
    type: InteractionType;
    subject: string;
    notes: string;
    contactId: string | null;
    occurredAt: string;
  }) => {
    if (!editInteraction?.id) {
      return;
    }

    try {
      await updateExistingInteraction(editInteraction.id, values);
      setEditInteraction(null);
      toast.success("Interaction updated successfully");
    } catch (error) {
      console.error("Error updating interaction:", error);
      toast.error("Failed to update interaction");
    }
  };

  const handleDeleteInteraction = async (interactionId: string) => {
    try {
      await deleteInteraction(interactionId);
      toast.success("Interaction deleted successfully");
    } catch (error) {
      console.error("Error deleting interaction:", error);
      toast.error("Failed to delete interaction");
    }
  };

  const openAddModal = (type: InteractionType = 1) => {
    setInteractionType(type);
    setIsAddOpen(true);
  };
  const closeAddModal = () => setIsAddOpen(false);
  const openEditModal = (interaction: NonNullable<ProspectDto["interactions"]>[number]) =>
    setEditInteraction(interaction);
  const closeEditModal = () => setEditInteraction(null);

  return {
    
    closeAddModal,
    
closeEditModal,
    
editInteraction,
    
    
// Form handlers
handleAddInteraction,
    


handleDeleteInteraction,
    


handleUpdateInteraction,
    


interactionType,
    
    
// Modal states
isAddOpen,
    // Modal actions
openAddModal,
    openEditModal,
  };
};
